export const CHECKOUT_CART_MACHINE_ID = 'checkout-cart';
